<template>
  <div>
    <template v-if="layout==authLayout">
      <auth-layout></auth-layout>
    </template>
    <template v-if="layout==appLayout">
      <app-layout></app-layout>
    </template>
    <!-- Progress Bar -->
    <v-dialog v-model="loader" width="70">
      <v-progress-circular :size="70" color="info" class="overflow-hidden" indeterminate></v-progress-circular>
    </v-dialog>
    <v-snackbar v-if="snackbar.show" bottom :color="snackbar.color" v-model="snackbar.show">
      {{snackbar.text }}
      <v-btn icon color="white">
        <v-icon small class="black--text" @click="snackbar.show = false">close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import AuthLayout from "@/layouts/AuthLayout";
import AppLayout from "@/layouts/AppLayout";
import { EventBus } from "@/event-bus";
import { mapGetters } from "vuex";
import DEFINES from "@/defines";
import i18n from "@/i18n";

export default {
  name: "app",
  components: {
    AuthLayout,
    AppLayout
  },
  data() {
    return {
      loader: false,
      snackbar: {
        show: null,
        text: "",
        color: ""
      },
      appLayout: DEFINES.LAYOUT_APP,
      authLayout: DEFINES.LAYOUT_AUTH
    };
  },
  computed: {
    ...mapGetters("app", {
      layout: "appLayout"
    })
  },

  created() {
    EventBus.$on("showMessage", payload => {
      this.snackbar = {
        show: true,
        color: payload.color,
        text: i18n.t(payload.message)
      };
    });
    EventBus.$on("showLoader", payload => {
      this.loader = true;
    });
    EventBus.$on("hideLoader", payload => {
      this.loader = false;
    });
  }
};
</script>
